export default "__VITE_ASSET__TUJL1ysB__"